import { render, staticRenderFns } from "./SectionReasonOne.vue?vue&type=template&id=48ab7c06&scoped=true&"
import script from "./SectionReasonOne.vue?vue&type=script&lang=js&"
export * from "./SectionReasonOne.vue?vue&type=script&lang=js&"
import style0 from "./SectionReasonOne.vue?vue&type=style&index=0&id=48ab7c06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ab7c06",
  null
  
)

export default component.exports